import React from 'react';
import { SafeImg } from '../../SafeImg';
import { Btn, H1, Eyebrow, tidFor, E } from './_shared';

/* ════════════════════════════════════════════════════════════════════════
 * EDITORIAL — new variants (dark-violet-block · sub-card)
 * Iter 175c — title · tagline · author · role · aside_label · aside_text editable.
 * ════════════════════════════════════════════════════════════════════════ */
export function EditorialExt({ block, theme, E: EProps = {} }) {
  const { onEdit } = EProps;
  const c = block.content || {};
  const layout = block.layout;

  if (layout === 'dark-violet-block') {
    return (
      <section data-block-type={block.type} data-layout={block.layout || "default"} className="px-8 py-20" style={{ background: '#3B1F8B' }}>
        <div className="max-w-3xl mx-auto text-white text-center">
          <E block={block} onEdit={onEdit} field="title" value={c.title || c.text || 'Your manifesto here.'} tag="h2" className="text-3xl md:text-4xl font-bold leading-tight" style={{ fontFamily: theme.headingFont }} placeholder="Headline" />
          <E block={block} onEdit={onEdit} field="tagline" value={c.tagline || ''} tag="p" className="mt-6 opacity-85 leading-relaxed" placeholder="Tagline" />
          <p className="mt-8 text-xs uppercase tracking-[0.2em] opacity-70">— <E block={block} onEdit={onEdit} field="author" value={c.author || ''} tag="span" placeholder="Author" />{c.role && <>, <E block={block} onEdit={onEdit} field="role" value={c.role} tag="span" placeholder="Role" /></>}</p>
        </div>
      </section>
    );
  }

  if (layout === 'sub-card') {
    return (
      <section data-block-type={block.type} data-layout={block.layout || "default"} className="px-6 py-16" style={{ background: theme.bg, color: theme.ink }}>
        <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-5 gap-6">
          <div className="md:col-span-3">
            <E block={block} onEdit={onEdit} field="title" value={c.title || 'Manifesto'} tag="h2" className="text-3xl font-bold" style={{ fontFamily: theme.headingFont }} placeholder="Headline" />
            <E block={block} onEdit={onEdit} field="text" value={c.text || c.tagline || ''} tag="p" className="mt-4 opacity-80 leading-relaxed" placeholder="Body" />
          </div>
          <div className="md:col-span-2 p-6 rounded-xl text-white" style={{ background: '#3B1F8B', borderRadius: theme.radius || 12 }}>
            <E block={block} onEdit={onEdit} field="aside_label" value={c.aside_label || 'Aside'} tag="p" className="text-xs uppercase tracking-wider opacity-80 font-bold mb-2" placeholder="Aside label" />
            <E block={block} onEdit={onEdit} field="aside_text" value={c.aside_text || 'Supporting note that complements the manifesto.'} tag="p" className="text-sm opacity-90" placeholder="Aside text" />
          </div>
        </div>
      </section>
    );
  }
  return null;
}
